import { CMSImage, type CMSImageProps } from "./cms-image";
import { SrcImage, type SrcImageProps } from "./src-image";

export { CMSImage } from "./cms-image";
export { SrcImage } from "./src-image";

interface ImageProps extends CMSImageProps, Pick<SrcImageProps, "src" | "alt" | "width" | "height"> {
	blurhash?: string | null;
}

/**
 * Renders an image from Payload CMS media collection or a direct URL.
 *
 * @param props - Component props.
 * @returns The rendered image element or null if no valid image source is provided.
 */
export const Image: React.FC<ImageProps> = ({ media, size, src, alt, width, height, ...props }) => {
	if (src) {
		return <SrcImage src={src} alt={alt} width={width} height={height} {...props} />;
	}

	return <CMSImage media={media} size={size} {...props} />;
};
